export default function DoctorCard({doctor, setDocData}) {
    return (
        <div className="doctor-card">
            <div className="doctor-card__header">
                <img src={doctor.image} alt="Doctor Image"/>
                <h2 className="title">{doctor.name}</h2>
            </div>
            <div className="doctor-card__body">
                <p>{doctor.description}</p>
            </div>
            <div className="doctor-card__footer">
                <button 
                    type="button"
                    className='btn-appointment' 
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (doctor && setDocData) {
                            setDocData(doctor);
                        }
                    }}
                >
                    Book Appointment
                </button>
            </div>
        </div>
    )
}

